import React from "react";
import ImageGallery from "react-image-gallery";
import styled from "styled-components";
import YakshaganaStringPuppetsSection from "../../components/forms/TwoColContactUsWithIllustration";

import image3 from "./Puppet Academy/01. Monthly Programs Held/IMG_0300.JPG";
import image1 from "./Puppet Academy/01. Monthly Programs Held/IMG-20200711-WA0086-ink.jpeg";
import image2 from "./Puppet Academy/01. Monthly Programs Held/Stage.JPG";
import image4 from "./Puppet Academy/01. Monthly Programs Held/Sudhamurthy- P.2.JPG";
import image5 from "./Puppet Academy/01. Monthly Programs Held/Dayananda Pai.jpg";
import photo from "./Puppet Academy/01. Monthly Programs Held/IMG_8604-ink-min.jpeg";

const SliderMain = styled.div`
  margin-bottom: 50px;
  margin-left: 100px;
  padding: 100px;
  padding-top: 0;
  @media (min-width: 320px) and (max-width: 480px) {
    padding: 10px;
    margin-left: 0;
  }
  .image-gallery-slide-wrapper {
    background: black !important;
  }
  h1 {
    font-size: 24px;
    font-weight: bold;
  }
  ul {
    margin: 20px 0 20px 50px;
    list-style: decimal-leading-zero;
    /* list-style-type: none; */
    /* counter-reset: item; */

    li {
      padding: 5px;
      /* counter-increment: item; */
      /* &:before {
        display: inline-block;
        width: 1.5em;
        padding-right: 0.5em;
        font-weight: bold;
        text-align: right;
        content: counter(item) ".";
      } */
    }
  }
`;

const images = [
  {
    original: image1,
    thumbnail: image1,
    description: "Puppet Akademy Building",
  },
  {
    original: image2,
    thumbnail: image2,
    description: "Kogga Devanna Kamath Theater",
  },
  {
    original: image3,
    thumbnail: image3,
    description: "Seating arrangements in Theater",
  },

  {
    original: image4,
    thumbnail: image4,
    description: "We are deeply indebted to Dr.Sudha Murthy",
  },
  {
    original: image5,
    thumbnail: image5,
    description: "We are deeply indebted to Dr.P.Dayananda Pai",
  },
];

export default function ProgramsHeld() {
  return (
    <div>
      <YakshaganaStringPuppetsSection title={"About Akademy"} image1={null} />
      <SliderMain>
        <img src={photo} alt="photo" />
        <br />
        <p>
          We are proud to introduce two great personalities of our country one
          being Dr. Sudhamurthy, Chair person, Infosys Foundation, Bengaluru and
          another Dr. P. Dayananda Pai, eminent industrialist, Bengaluru . With
          the help and guidance from these two well known personalities, a dream
          of our ancestors has become true. A well built huge “PUPPET AKADEMY
          BUILDING” with an estimated cost of Rs. One Crore has come up in our
          Uppinakudru, a small coastal village of Karnataka giving opportunity
          to exhibit not only puppetry programmes but also to different fields
          of literary and other art activities. This was inaugurated on 7 th
          March of 2015 and we are now in the 5 th year of its inception. Every
          month we have one or the other programme by the people local or
          neighbouring areas giving opportunity to expose their talents and we
          are happy to record that many of such programmes were over crowded
          beyond our expectation. We have already arranged 61 monthly programmes
          one each month so far which was possible by their over whelming
          encouragement.
        </p>
        <br />
        <h1>
          61 Monthly programmes held in Uppinakudru Puppet Academy in Five years
        </h1>
        <ul>
          <li>07-03-2015 - Inauguration of Uppinakudru Puppet Akademy.</li>
          <li>
            19-04-2015 - choodamani Lanka Dahana Puppet show by Sri Ganesha
            Yakshagana Gombeyata Mandali, Uppinakudru.
          </li>
          <li>24-05-2015 – Light Music by Sri Ganesha Gangolli.</li>
          <li>
            14-06-2015 - Yakshagana Gana Vaibhava by Sri Herenjalu Gopala Ganiga
            & Team.
          </li>
          <li>
            26-07-2015 - Yakshagana Tala Maddale by Sri Herenjalu Gopala Ganiga
            & Team.
          </li>
          <li>
            15-08-2015 - Cultural programmes by the students of Uppinakudru
            schools on the occasion Of Independence Day Celebration.
          </li>
          <li>
            13-09-2015 - Yakshagana by Sri Durgaparameshwari Girl’s Yakshagana
            Troupe, Hemmadi.
          </li>
          <li>18-10-2015 - Yakshagana by Sri Sai Kala Prathistana, Shimoga.</li>
          <li>15-11-2015 - Yakshagana play by Saligrama Childrens’ Troupe</li>
          <li>
            20-12-2015 - Yakshagana Bayalata by the students of Uppinakudru
            Puppet Akademy.
          </li>
          <li>
            15-01-2016 - Yakshagana Gombeyata by Sri Gopalakrishna Yakshagana
            Bembeyata Sangha Kasaragod.
          </li>
          <li>
            14-02-2016 - Yakshagana by the members of Namma Kala Kendra,
            Koteshwara.
          </li>
          <li>13-03-2016 - Yakshagana by Hangarkatte Kala Kendra.</li>
          <li>
            24-04-2016 - 1st Annual Day Celebration of Uppinakudru Puppet
            Akademy.
          </li>
          <li>
            15-05-2016 - Tribute to Sitar Player Sri Avinash Hebbar, Kundapura{" "}
          </li>
          <li>19-06-2016 - Folk and Light music by Sri Ganesh Gangolli.</li>
          <li>24-07-2016 - Bhajan by Smt. Pramila Kundapura.</li>
          <li>
            15-08-2016 - Cultural programmes by the students of Uppinakudru
            schools on the occasion Of Independence Day Celebration.
          </li>
          <li>
            18-09-2016-Light music by the members of Sri Annapurneshwari Blind
            Geeta Gayana Sangha, Shirasi.
          </li>
          <li>
            16-10-2016 - Yakshagana Tala Maddale by Sri Ranjeet Kumar Shetty,
            Vakwadi & Team.
          </li>
          <li>
            27-11-2016 - Mono Yakshagana play by Sri Mantapa Prabhakar Upadhya,
            Bengaluru.
          </li>
          <li>
            18-12-2016 - Bhajan by Sri Laxmi Venkatesh Bhajana Mandali,
            Kundapura.
          </li>
          <li>
            15-01-2017 - Kala Kusumanjali by Stuthi Event Management, Kundapura.
          </li>
          <li>12-02-2017 - Gindi Dance by Sri Sathish Nayak, Guddeangady.</li>
          <li>26-03-2017 - Harmonium Solo by Sri Sudheer Nayak, Mumbai.</li>
          <li>
            16-04-2017 - 2nd Annual Day Celebration of Uppinakudru Puppet
            Akademy.
          </li>
          <li>
            07-05-2017 - Bhajan& Devotional Songs by Vidwan Sri Vageesh Bhat,
            Bengaluru.
          </li>
          <li>18-06-2017 - Ganasudha by Sri Prakash Shenoy & team Gangolli.</li>
          <li>
            16-07-2017 - Bhajan Sandhya by Sri Siddi Vinayaka Mahila Bhajan
            Sangha, Kundapura.
          </li>
          <li>
            15-08-2017 - Cultural programmes by the students of Uppinakudru
            schools on the occasion Of Independence Day Celebration
          </li>
          <li>
            17-09-2017 - Konkani Rasamanjari by Smt. Narmada Prabhu, Tekkatte.
          </li>
          <li>
            15-10-2017 - Bhajan by Tallur Vittal Temple Bhajana team & Sri
            Sathish Nayak Guddeangady & team.
          </li>
          <li>
            19-11-2017 - Harikatha Satsangha by Haridas Sri B.C.Rao Shivapura.
          </li>
          <li>
            17-12-2017 - Hindusthani Classical Music by Sadhana Kala Sangama,
            Kundapura.
          </li>
          <li>
            21-01-2018 - Bhajan Sandhya by Sri Laxmi Venkatesh Bala Bhajana
            Mandali, Pete Sri Venkataramana Temple, Kundapura.
          </li>
          <li>
            18-02-2018 - Devotional Songs by Smt. Madhushree S.Pai, Koteshwara.
          </li>
          <li>
            18-03-2018 - Light Music by Kum. Kruthika Shenoy K. Kundapura.
          </li>
          <li>
            29-04-2018 - 3rd Annual Day Celebration of Uppinakudru Puppet
            Akademy.
          </li>
          <li>
            20-05-2018 - Karnataka Sangeetha & Light Music by Smt. Nalini
            Venkatramana Rao.
          </li>
          <li>
            17-06-2018 - Devotional songs by Sri K. Ramesh Pai, Kundapura.
          </li>
          <li>
            15-07-2018 - Kunitha Bhajan by Sri Mani Siddalingeshwara Bhajana
            Mandali, Movadi.
          </li>
          <li>
            15-08-2018 - Cultural programmes by the students of Uppinakudru
            schools on the occasion Of Independence Day Celebration.
          </li>
          <li>
            23-09-2018 - Light Music by the students of Sadhana Kala Sangama,
            Kundapura.
          </li>
          <li>
            21-10-2018 - Bharathanatyam by Dr. Malavika Hebbar, Kundapura.
          </li>
          <li>
            04-11-2018 - Swara Sandhya by Kum. Shraddha Om Ganesh, Uppunda.
          </li>
          <li>09-12-2018 - Karnatic Light Music by Kum. Poorvi Chathra.</li>
          <li>20-01-2019 - Dasa Keerthanas by Smt. Pooja Bhat, Chempi.</li>
          <li>17-02-2019-Devotional Songs by Master Rakshan.</li>
          <li>10-03-2019 - Hindusthani Classical Music by Kum. Anusha Bhat.</li>
          <li>
            07-04-2019 - 4th Annual Day Celebration and 50th programme of
            Uppinakudru Puppet Akademy.
          </li>
          <li>
            19-05-2019-Inauguration of “ Walkthrough of Students towards Puppet
            House” - Cultural programmes by the students of New Aided Higher
            Primary School, Bantwadi and Anganawadi students of Uppinakudru.
          </li>
          <li>
            29-06-2019 - Cultural programmes by Narayana Special Children’s
            School, Tallur and Govt. Higher Primary School. Tallur.
          </li>
          <li>
            20-07-2019-Programmes by the students of B.R.Rao’s Hindu Higher
            Primary School, Kundapura.
          </li>
          <li>
            15-08-2019 - Cultural programmes by the students of Uppinakudru
            schools on the occasion Of Independence Day Celebration.
          </li>
          <li>
            28-09-2019 - Various cultural programmes by the students of Govt.
            High School, Hakladi.
          </li>
          <li>
            10-10-2019 - Programmes by the students of Sri Venkatramana English
            Medium School, Kundapura.
          </li>

          <li>
            15-11-2019 - Programmes by the students of Sri Siddhi Vinayaka
            Residential School,Hattiangady.
          </li>
          <li>
            16-12-2019 - Chinnara Kalarava by Uppinakudru three Anganavadi kids.
          </li>
          <li>
            18-01-2020 - Cultural programmes by the students of Govt. Higher
            Primary School, Gujjadi.
          </li>
          <li>
            22-02-2020 - Programmes by the students of Govt. Higher Primary
            School, Maravanthe.
          </li>
          <li>
            07-03-2020 - Various cultural programmes by the students of Sri
            Saraswathi Vidyalaya English Medium School, Gangolli.
          </li>
          <li>04-11-2020 – Inauguration of Photo Gallery and Redesigned Trust web site www.yakshaganapuppets.org</li>
          <li>10-01-2021 – 6th Annual Day Celebration of Uppinakudru Puppet Akademi</li>
          <li>14-03-2021 – Hindusthani Vocal by Dr. H.R. Hebbar, Kundapura</li>
          <li>11-04-2021 – “Bhajan Sandhya” by Smt. Devaki Suresh Prabhu, Tallur</li>
          <li>24-10-2021 – Silver Jubilee of Trust and Centenary Celebration of Kogga Devanna Kamath</li>
          <li>28-11-2021 – “Kunitha Bhajan” by Sumana Acharya ND Team, Trasi</li>
          <li>26-12-2021 – Sri Ramanama Sankeerthana Mahila Bhajana Mandali, Kumbhashi and Sri Rama Bhajana Mandira Mahila Team, Gopadi</li>
          <li>20-03-2022 – 7th Annual Day Celebration of Uppinakudru Puppet Akademi</li>
          <li>24-04-2022 – “Light Music” by Sri Venugopal Bhat, Koteshwara</li>
          <li>03-05-2022 – “Soothra Sankalpa” one day free Puppet workshop for School children</li>
          <li>19-06-2022 – Yakshagana Tala Maddale “Sri Krishna Sandhana” sponsored by Sri Venkataramana Biduval, Herur</li>
          <li>17-07-2022 – Yakshagana Tala Maddale by Kala Ranga Nirasale, Koteshwara</li>
          <li>15-08-2022 – Independence Day Celebration sponsored by Netaji Committee Friends, Uppinakudru</li>
          <li>11-09-2022 – “Sangeetha Sanje” by Sri Janardhana Hande, Mangaluru</li>
          <li>16-10-2022 – “Bhajan Sandhya” by Smt. Jayamala Shenoy, Mangaluru</li>
          <li>20-11-2022 – “Paniyappayya Award” in remembrance of Late Shiroor Phaniyappayya sponsored by Phanigiri Prathistana, Shiroor</li>
          <li>18-12-2022 – Bhajan by Sri Kundeshwara Bhajana Mandali, Kundapura and Sri Ramanjaneya Bhajana Mandali, Kalyanpura</li>
          <li>15-01-2023 – “Light Music” by Master Anurag Nayak, Trasi</li>
          <li>05-02-2023 – 8th Annual Day Celebration of Uppinakudru Puppet Akademi</li>
          <li>08-03-2023 – International Women’s Day Celebration</li>
          <li>09-04-2023 – “Harikatha Kalakshepa” by Smt. Mundashi Swetha Sudha Pai, Udupi</li>
          <li>21-05-2023 – Inauguration of “Soothra Ranga” outdoor stage and “Bhajan Sandhya” by Dr. Kashinath Pai, Gangolli</li>
          <li>18-06-2023 – “Bhakthi Sangeetha” by Smt. Maya Kamath, Mahamaya Bhajana Mandali, Manipal</li>
          <li>23-07-2023 – Bhajan by Sri Padmanabha Hebbar, Nagoor and Team</li>
          <li>15-08-2023 – Independence Day Celebration sponsored by Netaji Committee Friends, Uppinakudru</li>
          <li>10-09-2023 – “Bhajan Sandhya” by Smt. Ramya Mallya</li>
          <li>08-10-2023 – Music Concert by Kum. Bhavana Bhat on Violin and Kum. Priyadarshini Bhat, Harikhandige on Veena</li>
          <li>05-11-2023 – Chanting Bhagavad Gita by Smt. Rashmi Raj, Kundapura</li>
          <li>Donation and Inauguration of Garden Benches by Sri U.N. Anandaram Aithal, Mangaluru</li>
          <li>10-12-2023 – “Devotional Songs” by Sri Girish Nagesh Prabhu, Mangaluru</li>
          <li>28-01-2024 – 9th Annual Day Celebration of Uppinakudru Puppet Akademy</li>
          <li>11-02-2024 – Various Cultural programmes by Shivaprabha Yakshagana Kendra, Indrali, Udupi</li>
          <li>10-03-2024 – Women’s Day Celebration by GSB Mahila Vrinda, Kundapura</li>
          <li>07-04-2024 – Various Cultural programmes by Halmakki Jattigeshwara Bhajana Mandali, Suggibail, Gangolli</li>
          <li>19-05-2024 – “Bhajan Sandhya” by Venugopala Bhajana Mandali, Kundapura</li>
          <li>16-06-2024 – “Flute Concert” by Master Sham G.N. Poojari, Gangolli</li>
          <li>21-07-2024 – “Devotional Songs” by Shree Veera Venkatesha Bhajana Mandali, Mangaluru</li>
          <li>15-08-2024 – Independence Day Celebration sponsored by Netaji Committee Friends, Uppinakudru</li>
          <li>16-09-2024 – “Flute Concert and Vissel Songs” by Sri Shridhar Nayak, Guddeangadi</li>
          <li>27-10-2024 – Celebration of 100th Monthly programme – Various Cultural programmes From Udaya Raaga To Sandhya Raaga (5.00 am to 11 pm)</li>
          <li>24-11-2024 – “Yaksha Naada” by the students of Shivaprabha Yakshagana Kendra, Udupi</li>
          <li>22-12-2024 – “Bhajan Sandhya” by Tarangini Bhajana Mandali, Udupi and Release of Mythological Yakshagana Prasanga written by Dr. Shivakumar Alagodu</li>
          <li>19-01-2025 – 10th Annual Day Celebration and Conferring Kogga Devanna Kamath Award</li>
          <li>23-02-2025 – Bharathanatyam by Miss Praneetha Prashanth Nayak, Kota</li>
          <li>23-03-2025 – Discourse of Vishnusahasranama by Dr. Ramakanth Shenoy, Mysore and Devotional Songs by Miss Deeksha Pai and Miss Preksha Pai, Kundapura</li>
          <li>20-04-2025 – Dance by Master Vaibhav J. Poojari and Biduval Prathistana, Herooru</li>
          <li>23-05-2025 – “Light Music” by Miss Akanksha S. Pai, Kundapura</li>
          <li>15-06-2025 – “Bhajan” by Smt. Vasanthi R. Pandith, Kundapura</li>
          <li>21-07-2025 – Elocution by Miss Manvitha and Bhajan by Shree Ekanatheshwari Bhajana Mandali, Kundeshwara</li>
          <li>15-08-2025 – Independence Day Celebration sponsored by Netaji Committee Friends, Uppinakudru</li>
          <li>21-09-2025 – “Devotional Songs” by Miss Panchami Bhat, Mangaluru</li>
          <li>26-10-2025 – “Bhajan Songs” by Ekanatheshwari Bhajana Mandali, Kundeshwara</li>
          <li>29-10-2025 – Inauguration of “Puppet Museum” by Shreemad Samyamindra Thirtha Swamiji, Shree Kashi Math</li>
          <li>16-11-2025 – “Ganadhara Kathasara” by Sri Janardhan Hande, Mangaluru</li>
          <li>21-12-2025 – “Ghar Ghar Bhajan” by Kundapura Pete Shree Venkataramana Bhajana Team</li>
          <li>25-01-2026 – 11th Annual Day Celebration and Conferring Kogga Devanna Kamath Award</li>
        </ul>

        <ImageGallery items={images} />
      </SliderMain>
    </div>
  );
}
